import { RequestPriority } from '../queue/request/request-queue';

type InFlightEntry = {
  promise: Promise<any>;
  priority: RequestPriority;
};

export const profileInFlightRequests = new Map<string, InFlightEntry>();
export const catalogInFlightRequests = new Map<string, InFlightEntry>();
